<template>
    <div>
        <!-- <div v-if="localResources.any((r) => r.id)">
            
            <vs-icon
                icon-pack="feather"
                :icon="icon"
                class="icon-inputx notranslate vs-input--icon"
                @click="download"
            >
            </vs-icon>
        </div> -->

        <!-- v-else -->
        <!-- :value="filenames" -->
        <!-- @icon-click="download" -->
        <vx-input
            v-bind="$attrs"
            v-on="listeners"
            ref="input-file"
            icon="feather icon-upload"
            placeholder=""
            type="file"
            :rules="rules"
            :accept="allowTypes ? allowTypes.join(', ') : ''"
            :multiple="isMultiple"
            :name="name"
            :disabled="localResources.length >= limit"
        />
        <!-- <div
            v-if="localResources && localResources.length > 0"
            class="ml-4"
            style="overflow: hidden"
        >
            <div
                v-for="(file, index) in localResources"
                :key="file.filename"
                :index="index"
                class="mb-1"
            >
                <vx-chip class="mt-2" color="primary">
                    <vx-action-icon
                        icon="DownloadIcon"
                        class="btn-drop download"
                        size="4"
                        active-color="black"
                        color="inherit"
                        @click="download(index)"
                    />
                    {{ file.filename }}
                    <vx-action-icon
                        v-if="!file.id"
                        icon="XCircleIcon"
                        class="btn-drop remove"
                        size="4"
                        active-color="black"
                        color="inherit"
                        @click="removeFile(index)"
                    />
                </vx-chip>
            </div>
        </div> -->
        <ul
            v-if="localResources && localResources.length > 0"
            class="ml-4 mb-4"
            style="overflow: hidden"
        >
            <li
                v-for="(file, index) in localResources"
                :key="index + '_' + file.filename"
                :index="index"
            >
                <vx-chip class="mt-2" color="primary">
                    <vx-action-icon
                        v-if="!!file.id"
                        icon="DownloadIcon"
                        class="btn-drop download"
                        size="4"
                        active-color="black"
                        color="inherit"
                        @click="download(index)"
                    />
                    {{ file.filename }}
                    <vx-action-icon
                        v-if="!file.id"
                        icon="XCircleIcon"
                        class="btn-drop remove"
                        size="4"
                        active-color="black"
                        color="inherit"
                        @click="removeFile(index)"
                    />
                </vx-chip>
            </li>
        </ul>
    </div>
</template>

<script>
import VxChip from '../VxChip.vue'
export default {
    components: { VxChip },
    name: 'vx-file-input',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        limit: {
            type: [Number, String],
            default: Infinity
        },
        allowTypes: {
            type: [String, Array],
            default: () => []
        },
        sizeLimit: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: 'File'
        }
    },
    watch: {},
    data() {
        return {}
    },
    computed: {
        localResources: {
            get() {
                return this.value
            },
            set(v) {
                if (!v) {
                    this.$emit('input', [])
                    return
                }
                // console.log('Setting', v, this.value)
                // if (this.value.length > 0) {
                //     this.value.push(v)
                //     console.log('Set', this.value)
                //     this.$emit('input', this.value)
                //     return
                // }
                this.$emit('input', v)
            }
        },
        localFiles() {
            return this.localResources.map((f) => f.file).nonNull()
        },
        isMultiple() {
            return this.limit > 1
        },
        inputType() {
            return this.value && this.value.any() ? 'text' : 'file'
        },
        filenames() {
            if (!this.localResources || !this.localResources.any()) {
                return null
            }
            return this.localResources.map((f) => f.filename).textualize('and')
        },
        listeners() {
            return {
                ...this.$listeners,
                change: this.onFileChange,
                input: this.onInput
            }
        },
        rules() {
            return [this.validateFileCount, this.validateFileType, this.validateFileSize]
        },
        icon() {
            return this.value && this.value.any() ? 'icon-download' : 'icon-upload'
        }
    },
    methods: {
        onInput(v) {
            if (!v) {
                this.localResources = []
            }
        },
        validateFileCount() {
            if (this.localResources.length > this.limit) {
                return `Too many files. Limit is ${this.limit}`
            }
            return true
        },
        validateFileSize() {
            if (
                this.sizeLimit &&
                this.localFiles.any((file) => file && file.size > this.sizeLimit)
            ) {
                return `File too large. All files must be under ${this.sizeLimit.asByteSize()}.`
            }
            return true
        },
        validateFileType() {
            if (this.localFiles && this.localFiles.any(this.isInvalidType)) {
                var pluralizer = this.allowTypes.length > 1 ? 's' : ''
                return `${this.name} only accepts type${pluralizer}: ${this.allowTypes.textualize(
                    'or'
                )}`
            }
            return true
        },
        isInvalidType(file) {
            return this.allowTypes.any((t) => {
                if (file) {
                    return (
                        !file.type ||
                        !(file.type.startsWith(`${t}/`) || file.type.endsWith(`/${t}`))
                    )
                }
            })
        },
        async onFileChange(e) {
            try {
                this.loading = true
                var files = e.target.files || e.dataTransfer.files
                this.localResources = [
                    ...this.localResources,
                    ...(await this.createFileList(files))
                ]
            } catch (error) {
                this.notifyError('Upload Failed', 'One of more of the file uploads failed')
            } finally {
                this.loading = false
            }
        },
        async createFileList(files) {
            var newFiles = [...files]
            var resourceList = []
            for (var i = 0; i < newFiles.length; i++) {
                var file = newFiles[i]
                var resource = {
                    filename: file.name,
                    mimeType: file.type,
                    id: null,
                    src: await file.toBase64(),
                    file: file
                }
                resourceList.push(resource)
            }
            return resourceList
        },
        download(index) {
            if (this.localResources && this.localResources.length > 0) {
                this.$api.resources.download(this.localResources[index])
            }
        },
        removeFile(index) {
            this.localResources = this.localResources.toSpliced(index, 1)
        }
    }
}
</script>

<style lang="scss" scoped>
.vx-chip {
    ::v-deep .vx-basic-icon,
    .download,
    .remove {
        height: 12px !important;
        width: 12px !important;
    }
    .download {
        margin-right: 6px !important;
    }
    .remove {
        margin-left: 6px !important;
        margin-right: -2px !important;
    }
}
</style>
